<template>
    <div>
        <el-dialog
            :title="title"
            width="500px"
            :visible="show"
            :before-close="beforeClose"
            v-loading="processing"
            :append-to-body="true"
            @close="onCancelClick"
        >
            <el-form
                :model="form"
                ref="form"
                label-width="200px"
                label-position="top"
                :rules="rules"
                v-loading="processing"
            >
                <el-form-item label="Triger deposit min amount" prop="min_amount">
                    <el-input
                        v-model="form.min_amount"
                        autocomplete="off"
                        type="number"
                        min="0"
                        clearable
                    >
                        <template slot="append">{{currency.asset_name}}</template>
                    </el-input>
                    <!-- <div class="hint">This Deposit Info will be provided to user for deposit amount less than or equal to {{form.min_amount}} {{currency.asset_name}}</div> -->
                </el-form-item>
                <el-form-item label="Triger deposit max amount" prop="max_amount">
                    <el-input
                        v-model="form.max_amount"
                        autocomplete="off"
                        type="number"
                        min="0"
                        clearable
                    >
                        <template slot="append">{{currency.asset_name}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Description" prop="description">
                    <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"></ckeditor>
                </el-form-item>
                
            </el-form>
            <el-alert
                :title="`This Deposit Info will be provided to user for deposit amount greater than ${form.min_amount} ${currency.asset_name}, less than or equal to ${form.max_amount} ${currency.asset_name}`"
                type="info"
                show-icon
                v-if="form.max_amount>0"
            ></el-alert>

            <div slot="footer" class="dialog-footer" v-loading="processing">
                <el-button @click="onCancelClick">Cancel</el-button>
                <el-button @click="onDelete" v-if="deposit_info" type="danger">Delete</el-button>
                <el-button @click="onSubmit" type="primary">Save</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
    name: "AdminCurrencyDepositInfoNew",
    components: {},
    props: {
        currency: Object,
        deposit_info: Object,
        show: { default: false },
        onClose: Function
    },
    data() {
        return {
            editor: ClassicEditor,
            form: {
                currency_id: this.currency.id,
                min_amount: 0,
                max_amount: 0,
                description: ""
            },
            showNewRole: false,
            processing: false,
            processing_search: false,
            rules: {
                max_amount: [
                    {
                        required: true,
                        message: "Max amount is required",
                        trigger: "blur"
                    }
                ],
            }
        };
    },
    watch: {
        deposit_info(newData) {
            if (newData) {
                this.form.currency_id = newData.currency_id;
                this.form.min_amount = newData.min_amount;
                this.form.max_amount = newData.max_amount;
                this.form.description = newData.description;
            } else {
                this.form = {
                    currency_id: this.currency.id,
                    min_amount: 0,
                    max_amount: 0,
                    description: ""
                };
            }
        },
        currency(currency) {
            if (currency) {
                this.form.currency_id = this.currency.id;
            }
        }
    },
    mounted() {
        if (this.deposit_info) {
            this.form.currency_id = this.deposit_info.currency_id;
            this.form.min_amount = this.deposit_info.min_amount;
            this.form.max_amount = this.deposit_info.max_amount;
            this.form.description = this.deposit_info.description;
        }
    },
    computed: {
        ...mapState({
            editorConfig: state => state.editorConfig
        }),
        title() {
            if (this.deposit_info) {
                return `Edit deposit info setting for currency ${this.currency.asset_name}`;
            }
            return `Add deposit info setting for currency ${this.currency.asset_name}`;
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        beforeClose(done = () => {}) {
            (this.form = {
                currency_id: null,
                min_amount: 0,
                max_amount: 0,
                description: ""
            }),
                done();
        },
        onCancelClick(reload = false) {
            this.onClose(reload);
        },
        onSubmit() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.form.currency_id = ctrl.currency.id;
            let method = "POST";
            let endpoint = `currencies/${ctrl.currency.asset_name}/deposit_info`;
            if (ctrl.deposit_info) {
                method = "PATCH";
                endpoint = `currencies/${ctrl.currency.asset_name}/deposit_info/${ctrl.deposit_info.id}`;
            }
            ctrl.request({
                method,
                endpoint,
                data: ctrl.form
            })
                .then(() => {
                    let message = "Deposit info setting has been added";
                    if (!ctrl.deposit_info) {
                        message = "Deposit info setting has been updated";
                    }
                    ctrl.$message({
                        message,
                        type: "success"
                    });

                    this.form = {
                        currency_id: null,
                        min_amount: 0,
                        max_amount: 0,
                        description: ""
                    }
                    ctrl.onClose(true);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_DEPOSIT_INFO_ERROR",
                        message: "Deposit info operation failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing = false;
                });
        },
        onDelete() {
            let ctrl = this;
            ctrl.$confirm(
                `Do you wish to remove deposit info?`,
                "Delete deposit info",
                {
                    confirmButtonText: `Confirm`,
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    ctrl.processing = true;
                    let method = "DELETE";
                    let endpoint = `currencies/${ctrl.currency.asset_name}/deposit_info/${ctrl.deposit_info.id}`;
                    ctrl.request({
                        method,
                        endpoint
                    })
                        .then(() => {
                            let message =
                                "Deposit info setting has been removed";
                            ctrl.$message({
                                message,
                                type: "success"
                            });
                            ctrl.onClose(true);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "CURRENCY_SETTING_ERROR",
                                message: "Remove Deposit info setting failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            ctrl.processing = false;
                        });
                })
                .catch(() => {});
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.permission-detail-item {
    display: flex;
    line-height: 26px;
    border-bottom: 1px solid #ccc;
}
.permission-detail-form-settings {
    border: 1px solid #ccc;
}
.permission-detail-item .title {
    width: 200px;
    text-align: right;
    background-color: rgba(0, 0, 0, 0.1);
    border-right: 1px solid #ccc;
}

.permission-detail-item .title span {
    padding: 0 8px;
}
.permission-detail-item .value {
    flex: 1;
}
.permission-detail-item .value span {
    padding: 0 8px;
}

.permission-detail-item:last-child {
    border-bottom: none;
}

.setting-section-title {
    font-size: 18px;
    padding: 0 8px;
    line-height: 30px;
}

.setting-section {
    padding: 8px;
}

.setting-section-content {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.permission-setting-content-items {
    display: flex;
    flex-direction: column;
}
.display_name {
    font-weight: 600;
}
</style>
